// extracted by mini-css-extract-plugin
export default {"container":"InputSingleValue_container__oU6IY","warning":"InputSingleValue_warning__eWha5"};